import { render, staticRenderFns } from "./IconFolder.vue?vue&type=template&id=1646d785&"
import script from "./IconFolder.vue?vue&type=script&lang=js&"
export * from "./IconFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports